import { useState } from 'react';
import { Loader } from '@quero-delivery/quero-components-web';
import { Modal } from '@querodelivery/uni-react';
import styles from './styles.module.scss';
import { MODAL_WIDTH } from '@/_constants/styles';

export interface ModalShowDocsProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string | string[];
  title: string;
}

function ModalShowDoc({ open, onClose, imageUrl, title }: ModalShowDocsProps) {
  const [showLoad, setShowLoad] = useState(true);

  const isArray = Array.isArray(imageUrl);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width={MODAL_WIDTH.lg}
      header={title}
    >
      {showLoad && <Loader size="sm" />}
      {isArray ? (
        <div className={styles.container}>
          <div className={styles.boxContainer}>
            {imageUrl.map(url => (
              <img
                data-testid={`img-${url}`}
                onLoad={() => setShowLoad(false)}
                key={url}
                src={url}
                alt="Imagem do documento"
              />
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <img
            onLoad={() => setShowLoad(false)}
            src={imageUrl}
            alt="Imagem do documento"
          />
        </div>
      )}
    </Modal>
  );
}

export { ModalShowDoc };
